import * as React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Shop} from 'interfaces';
import {CardMetric} from '../CardMetric';
import * as locales from '../../locales';
import * as styles from './CardMetrics.scss';

export type CardMetricTypes = 'avgRevenue' | 'avgProfit' | 'inventoryValue' | 'askingPrice';
interface Metrics {
  key: CardMetricTypes;
  label: string;
  frequency?: string;
  value: number;
  emphasis: boolean;
}
interface CardMetricsProps {
  shop: Shop;
  showAskingPrice?: boolean;
  layout: string;
  metricsToShow?: CardMetricTypes[];
}

export function CardMetricsComponent({
  shop,
  layout,
  i18n,
  metricsToShow = ['avgRevenue', 'avgProfit', 'inventoryValue'],
}: CardMetricsProps & WithI18nProps) {
  const metrics: Metrics[] = [
    {
      key: 'avgRevenue',
      label: i18n.translate('avgRevenue'),
      frequency: i18n.translate('month'),
      value: shop.averageMonthlyRevenue,
      emphasis: false,
    },
    {
      key: 'avgProfit',
      label: i18n.translate('avgProfit'),
      frequency: i18n.translate('month'),
      value: shop.averageProfitPerMonth,
      emphasis: false,
    },
    {
      key: 'inventoryValue',
      label: i18n.translate('inventoryValue'),
      value: shop.inventoryValue,
      emphasis: false,
    },
    {
      key: 'askingPrice',
      label: i18n.translate('askingPrice'),
      value: shop.salePrice,
      emphasis: true,
    },
  ];

  const filteredMetrics = metricsToShow
    ? metrics.filter((metric) => metricsToShow.includes(metric.key))
    : metrics;

  return (
    <dl className={classNames(styles.metrics, styles.noMargin, styles[layout])}>
      {filteredMetrics.map((metric) => (
        <CardMetric key={metric.key} metric={metric} layout={layout} />
      ))}
    </dl>
  );
}

export const CardMetrics = withI18n({
  id: 'CardMetrics',
  fallback: locales.en,
})(CardMetricsComponent);
